<template>
  <LayoutDefault title="Настройка ролей в проектах" isShowHeader>
      <RoleListTable />
  </LayoutDefault>
</template>

<script>
import { onMounted } from 'vue'
import { useStore } from 'vuex'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import RoleListTable from '@/components/blocks/RolesListTable'

export default {
  name: 'RolesView',
  components: {
    LayoutDefault,
    RoleListTable
  },
  setup () {
    const store = useStore()

    onMounted(() => {
      setTimeout(() => {
        store.dispatch('setUsers')
      }, 1000)
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
